var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.48 3.46874C7.78641 2.66014 5.41922 2.26405 2.25 2.24999C1.95111 2.24593 1.65809 2.33308 1.41 2.49983C1.20637 2.63747 1.03968 2.82304 0.924597 3.04021C0.809512 3.25739 0.749555 3.49952 0.750002 3.7453V17.1562C0.750002 18.0628 1.395 18.7467 2.25 18.7467C5.58141 18.7467 8.92313 19.058 10.9247 20.9498C10.9521 20.9758 10.9865 20.9932 11.0237 20.9998C11.0608 21.0064 11.0991 21.0019 11.1338 20.987C11.1685 20.972 11.1979 20.9471 11.2186 20.9155C11.2393 20.8839 11.2502 20.847 11.25 20.8092V5.00718C11.2501 4.90056 11.2273 4.79517 11.1831 4.69813C11.139 4.60109 11.0745 4.51466 10.9941 4.44468C10.5356 4.05272 10.0263 3.72445 9.48 3.46874ZM22.59 2.49843C22.3418 2.33209 22.0488 2.24542 21.75 2.24999C18.5808 2.26405 16.2136 2.65827 14.52 3.46874C13.9737 3.72398 13.4643 4.05161 13.0055 4.4428C12.9252 4.5129 12.8609 4.59937 12.8168 4.69639C12.7728 4.79341 12.75 4.89874 12.75 5.0053V20.8083C12.75 20.8446 12.7607 20.88 12.7807 20.9103C12.8008 20.9405 12.8293 20.9641 12.8628 20.9782C12.8962 20.9923 12.9331 20.9961 12.9687 20.9893C13.0044 20.9825 13.0372 20.9654 13.0631 20.94C14.2664 19.7447 16.3781 18.7453 21.7519 18.7458C22.1497 18.7458 22.5312 18.5877 22.8125 18.3064C23.0938 18.0251 23.2519 17.6436 23.2519 17.2458V3.74577C23.2524 3.4995 23.1923 3.25688 23.0769 3.03934C22.9615 2.8218 22.7942 2.63603 22.59 2.49843Z",
    fill: "url(#paint0_linear_54_2496)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_54_2496",
    x1: 12.0009,
    y1: 2.24982,
    x2: 12.0009,
    y2: 21.0028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4586C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubject);
export default __webpack_public_path__ + "static/media/subject.f79d02b51c055c92d47408edff1d8b98.svg";
export { ForwardRef as ReactComponent };